import React from 'react'
import { StyleSheet, View } from 'react-native'

import * as cth from '@/router/(root)/cth/cthModule'

import { CthBackground as Background } from "@/components/Mini/Background"
import { CthHeader as Header } from "@/components/Mini/Header"
import { CthLogCard as LogCard } from "@/components/Mini/HistoryCard"


export const CthLogScreen = () => {
  const handleClose = cth.useHandleClose()

  return (
    <Background>
      <Header title="Your Stats" handler={handleClose} />
        <View style={styles.body}>
          <LogCard />
        </View>
    </Background>
  )
}

const styles = StyleSheet.create({
  fill: { flex: 1 },
  body: { flex: 1 }
})
